import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { List, ArrowBack } from '@mui/icons-material';
import { currencies } from '../../assets/templates';
import logo from '../../assets/vector.svg';
import SelectList from '../ui/SelectList';

const Navbar = ({
  setShowSidebar,
  user,
}) => {
  const url = useLocation();
  const handleClick = async () => {
    if (document.querySelector('aside')?.classList.contains('disappear-bar')) {
      document.querySelector('aside')?.classList.remove('disappear-bar');
    } else {
      document.querySelector('aside')?.classList.add('disappear-bar');
    }
  };

  return (
    <nav>
      {(url.pathname === '/metior/' || url.pathname === '/metior')
        ? (
          <List id="sidebar-handler" onClick={() => { setShowSidebar(true); handleClick(); }} className="list-icon" />
        )
        : (
          <Link className="none-styles" to="/metior/">
            <ArrowBack style={{ height: '100%' }} />
          </Link>
        )}
      <div className="aligned-items navbar-logo-item">
        <img
          src={logo}
          alt="logo_sagaon"
          className="sagaon-logo"
        />
        <p>beta</p>
      </div>
      <div className="aligned-items navbar-item">
        {(url.pathname === '/metior/' || url.pathname === '/metior')
          ? (
            <SelectList
              className="currency-select"
              value=""
              placeholder="Seleccionar opcion"
              list={currencies}
            />
          )
          : (
            <div style={{ width: '50px' }} />
          )}
        {!user
          ? (
            <Link to="/metior/login">
              <button
                style={{ marginRight: '10px' }}
                type="button"
                className="login-navbar-button"
              >
                Inicia Sesion
              </button>
            </Link>
          )
          : (
            <button
              style={{ marginRight: '10px' }}
              type="button"
              className="login-navbar-button"
              onClick={() => { localStorage.clear(); window.location.reload(); }}
            >
              Cerrar Sesion
            </button>
          )}
      </div>
    </nav>
  );
};

Navbar.propTypes = {
  setShowSidebar: PropTypes.func.isRequired,
  user: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => (
  {
    user: state.user,
  });

const mapDispatchToProps = (dispatch) => ({
  setShowSidebar: (values) => dispatch({
    type: 'SET_SHOW_SIDE_BAR',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
